import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([Navigation]);

export function initImageCarousel(el) {
  const wrap = el.parentElement;
  const next = wrap.querySelector('.swiper-button-next');
  const prev = wrap.querySelector('.swiper-button-prev');
  const count = wrap.querySelector('.swiper-count');

  const updateSlideCount = (swiper) => {
    const currentSlide = swiper.realIndex + 1;
    const totalSlides = swiper.slides.length;
    count.textContent = currentSlide + '/' + totalSlides;
  }

  return new Swiper(el, {
    navigation: {
      nextEl: next,
      prevEl: prev
    },
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    on: {
      init: function () {
        updateSlideCount(this);
      },
      slideChange: function () {
        updateSlideCount(this);
      },
    }
  });
}

export function swiperCarousel() {
  const carousel = document.querySelectorAll('.js-swiper-carousel');
  if(carousel.length) {
    carousel.forEach((el,index) => {
      const wrap = el.parentElement;
      const wrapper = el.querySelector('.swiper-wrapper');
      const next = wrap.querySelector('.swiper-button-next');
      const prev = wrap.querySelector('.swiper-button-prev');
      const count = wrap.querySelector('.swiper-count');
      let mySwiper = '';
      let mySwiperBool = '';

      const getSwiperBool = () => {
        const beforeStr = getComputedStyle(el, ":before").content;
        if(beforeStr == '"swiper"') {
          mySwiperBool = true;
          const updateSlideCount = (swiper) => {
            const currentSlide = swiper.realIndex + 1;
            const totalSlides = swiper.slides.length;
            count.textContent = currentSlide + '/' + totalSlides;
          }
          mySwiper = new Swiper(el, {
            navigation: {
              nextEl: next,
              prevEl: prev
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            edgeSwipeThreshold: 100,
            grabCursor: true,
            on: {
              init: function () {
                updateSlideCount(this);
              },
              slideChange: function () {
                updateSlideCount(this);
              },
            }
          });
        } else {
          mySwiperBool = false;
          if(mySwiper !== '') {
            mySwiper.destroy(true,true);
            wrapper.removeAttribute('style')
          }
        }
      }
      let lastInnerWidth = window.innerWidth;
      let resizeSto = ''
      window.addEventListener("resize", function () {
        this.clearTimeout(resizeSto);
        resizeSto = setTimeout(() => {
          if(lastInnerWidth != window.innerWidth) {
            lastInnerWidth = window.innerWidth;
            getSwiperBool();
          }
        }, 300)
      });
      getSwiperBool()
    })
  }
}